import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Music } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center" data-testid="auth-loading">
        <Music className="animate-pulse text-primary" size={40} />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
};

export default ProtectedRoute;
